@let view = data();

<div [ngClass]="['position-' + view.view.image, 'grid-option-' + view.view.grid]" class="content-wrap">
  <div class="media">
    <ui-image [data]="view.media_content.media"></ui-image>
  </div>

  <div class="text">
    @if (view.headlines.tagline || view.headlines.headline || view.headlines.subline) {
      <ui-headlines [data]="view.headlines"></ui-headlines>
    }

    @if (view.content) {
      <div [innerHtml]="view.content" class="rte rte-themed" uiHtmlDataLink></div>
    }

    @if (view.button.link.label) {
      <a [link]="view.button.link" matButton="filled" uiContentLink>
        {{ view.button.link.label }}
      </a>
    }
  </div>
</div>
